import { twJoin } from 'tailwind-merge';

import { Para } from './Para';

type Props = {
  content: number | string;
  disabled?: boolean;
  suffix?: string;
};

export function BigDisplayField({ content, suffix, disabled = false }: Props): React.ReactElement {
  return (
    <div
      className={twJoin(
        'flex items-center justify-center',
        disabled ? 'opacity-50' : 'opacity-100',
      )}
    >
      <Para size="4xl" className="w-72 bg-zinc-100 py-3 text-zinc-800">
        {content}
        {suffix && ` ${suffix}`}
      </Para>
    </div>
  );
}
